import {
  Button,
  ButtonProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link
} from '@mui/material';
import toast from 'features/toast';
import { useState } from 'react';
import StyledDropzone from '../StyledDropzone';
import PublishIcon from '@mui/icons-material/Publish';
import { useTranslation } from 'react-i18next';

interface ImportFileUploaderProps {
  service: any;
  onUploadSuccess?: any;
  entityId?: number;
  templateGetterMethod?: any;
  importMethod?: any;
}

function ImportFileUploader(props: ImportFileUploaderProps) {
  const { t } = useTranslation();
  const { service, onUploadSuccess, entityId, templateGetterMethod, importMethod } = props;

  const [openDropzone, setOpenDropzone] = useState(false);
  const [fileToUpload, setFileToUpload] = useState<File | null>(null);

  const attachFile = () => {
    setOpenDropzone(true);
  };

  const handleUpload = () => {
    if (fileToUpload) {
      if (service.importFromFileDetail && entityId) {
        service.importFromFileDetail(fileToUpload, entityId).then(() => {
          if (onUploadSuccess) onUploadSuccess();
          toast.success(t('global.import-started'));
          setOpenDropzone(false);
        });
      } else if (importMethod) {
        importMethod(fileToUpload).then(() => {
          if (onUploadSuccess) onUploadSuccess();
          toast.success(t('global.import-started'));
          setOpenDropzone(false);
        });
      } else if (service.importFromFile) {
        service.importFromFile(fileToUpload).then(() => {
          if (onUploadSuccess) onUploadSuccess();
          toast.success(t('global.import-started'));
          setOpenDropzone(false);
        });
      }
    }
  };

  const handleClose = () => {
    setFileToUpload(null);
    setOpenDropzone(false);
  };

  const handleDrop = (acceptedFiles: File[]) => {
    if (!acceptedFiles.length) {
      toast.error(t('global.import-size-error'));
      return;
    }

    const file = acceptedFiles[0];
    if (file) {
      setFileToUpload(file);
    }
  };

  const importButtonProps: ButtonProps = {
    color: 'success',
    size: 'small',
    startIcon: <PublishIcon />
  };

  return (
    <>
      <Button {...importButtonProps} onClick={attachFile}>
        {t('data-grid.import')}
      </Button>
      <Dialog open={openDropzone}>
        <DialogTitle>{t(`import-modal.title`)}</DialogTitle>
        <DialogContent>
          <StyledDropzone onDrop={handleDrop} />
          <div className="mt-4">
            <Link
              underline="hover"
              onClick={() =>
                templateGetterMethod ? templateGetterMethod() : service.getImportTemplate()
              }
              className="cursor-pointer">
              {t('actions.download-template')}
            </Link>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t('actions.cancel')}</Button>
          <Button onClick={handleUpload} disabled={!fileToUpload}>
            {t('actions.upload')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ImportFileUploader;
